/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
import React, { useContext, useEffect } from 'react';
import { Box, Card, CardContent, Typography, Modal, Grid, Button } from '@mui/material';
import { withRouter } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import bundleIcon from '../../images/Done-saved.png';
import { SaveContinueModalStyles as classes } from '../Modal/SaveContinueModalStyles';

const SaveandContinueTextModal = () => {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);

  const { continueModal, setContinueModal, theme } = leadGenerationContext;
  const [open, setOpen] = React.useState(true);
  useEffect(() => {
    continueModal ? setOpen(true) : setOpen(false);
  }, [continueModal]);

  const handleConti = () => {
    setContinueModal(false);
    setOpen(false);
  };

  return (
    <Modal
      sx={classes.backdrop}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(233, 233, 235, 0.78)',
        },
      }}
      open={open}
      role="region"
      aria-describedby="dialog1BusinessDesc dialog2BusinessDesc"
    >
      <div style={{ outline: 'none' }} id="modalSave">
        <Card
          sx={{
            ...classes.rootConti,
            background: theme?.customBackground,
          }}
        >
          <CardContent sx={classes.card_content_simple_bundle}>
            <>
              <Box component="span" sx={classes.imgSize}>
                <img src={bundleIcon} alt="modal icon" />
              </Box>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignContent: 'center',
                  margin: '36px 0px',
                  maxWidth: '331px',
                }}
              >
                <Typography
                  sx={[
                    classes.textStyleConfirmModalBundle,
                    {
                      color: theme?.palette?.primary?.main,
                    },
                  ]}
                  id="dialog1BundleDesc"
                >
                  {t('Thank you!', {
                    defaultValue: 'Thank you!',
                  })}
                </Typography>
                <Typography
                  sx={[
                    classes.textStyleConfirmModal1,
                    classes.simpleCard_above_btn_bundle,
                    {
                      color: theme?.palette?.primary?.main,
                    },
                  ]}
                  id="dialog1BundleDesc"
                >
                  {t('Your request has been successfully saved.', {
                    defaultValue: 'Your request has been successfully saved.',
                  })}
                </Typography>
                <Typography
                  sx={[
                    classes.textStyleConfirmModal1,
                    {
                      color: theme?.palette?.primary?.main,
                    },
                  ]}
                  id="dialog1BundleDesc"
                >
                  {t('Please check your email to complete it later.', {
                    defaultValue: 'Please check your email to complete it later.',
                  })}
                </Typography>
              </div>
              <Grid container sx={classes.simple_Modal_bundle}>
                <Grid size={{ xs: 12 }}>
                  <Button
                    disableFocusRipple
                    variant="outlined"
                    sx={{
                      ...classes.saveAndExit_Confirm_bundle,
                      background: theme?.palette?.orientalPrimary?.main,
                      color: theme?.palette?.secondary?.main,
                      '&:hover': {
                        backgroundColor: theme?.palette?.orientalPrimary?.main,
                      },
                    }}
                    data-testid="CloseTryButtonInBusinessModal"
                    onClick={handleConti}
                  >
                    {t('Continue', { defaultValue: 'Continue' })}
                  </Button>
                </Grid>
              </Grid>
            </>
          </CardContent>
        </Card>
      </div>
    </Modal>
  );
};
export default withRouter(SaveandContinueTextModal);
